const UNITS: readonly [Intl.RelativeTimeFormatUnit, number][] = [
  ["year", 365 * 24 * 60 * 60_000],
  ["month", 30 * 24 * 60 * 60_000],
  ["week", 7 * 24 * 60 * 60_000],
  ["day", 24 * 60 * 60_000],
  ["hour", 60 * 60_000],
  ["minute", 60_000],
];

const format = new Intl.RelativeTimeFormat("en", { numeric: "auto" });
const counted = new Intl.RelativeTimeFormat("en", { numeric: "always" });

export function timeAgo(then: number, now: number = Date.now()): string {
  const elapsed = now - then;
  for (const [unit, ms] of UNITS) {
    if (Math.abs(elapsed) >= ms) {
      return format.format(-Math.round(elapsed / ms), unit);
    }
  }
  return "just now";
}

/**
 * Always a count, never "yesterday" or "last week", and whole units that
 * have fully passed, so it reads after a lead-in: "Read 1 day ago".
 */
export function timeSince(then: number, now: number = Date.now()): string {
  const elapsed = Math.max(0, now - then);
  for (const [unit, ms] of UNITS) {
    if (elapsed >= ms) return counted.format(-Math.floor(elapsed / ms), unit);
  }
  return "just now";
}
